import {IEmissionWebServiceClient} from "./../../common/resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class ReemissionResolver implements Resolve<Boolean> {

  constructor(private iEmissionWebServiceClient: IEmissionWebServiceClient) {
  }

  resolve() {
    console.log('isReemissionEnabled');
    return this.iEmissionWebServiceClient.isReemissionEnabled();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/reemission.resolver.ts